// @ts-ignore
import DashboardResult from 'generated/Result/SystemManagement/Models/LeoDashboardResult';
// @ts-ignore
import LeoDto from 'generated/Result/SystemManagement/Models/LeoDto';
import {
  GET_ORGS, RESET_ORGS, GET_ORG_PROFILE, RESET_ORG_PROFILE, DELETE_ORG_PROFILE,
  EDIT_ORG_PROFILE, ADD_ORG
} from 'redux/types/organization';
import { PayloadAction, RESET_STATE } from '../types/global';

export interface OrganizationState {
  getOrgs: DashboardResult,
  orgProfile: LeoDto,
  orgProfileDeleted: boolean,
  orgProfileEdited: boolean,
  orgProfileAdded: LeoDto
}

const INITIAL_STATE: OrganizationState = {
  getOrgs: null,
  orgProfile: null,
  orgProfileDeleted: null,
  orgProfileEdited: null,
  orgProfileAdded: null
};

const organizationReducer = function (
  state: OrganizationState = INITIAL_STATE,
  action: PayloadAction<any>
): OrganizationState {
  switch (action.type) {
    case RESET_STATE:
      return INITIAL_STATE;

    case GET_ORGS:
      return { ...state, getOrgs: action.payload };

    case RESET_ORG_PROFILE:
      return { ...state, orgProfile: null };

    case RESET_ORGS:
      return { ...state, getOrgs: null };

    case GET_ORG_PROFILE:
      return { ...state, orgProfile: action.payload };

    case DELETE_ORG_PROFILE:
      return { ...state, orgProfileDeleted: action.payload };

    case EDIT_ORG_PROFILE:
      return { ...state, orgProfileEdited: action.payload };

    case ADD_ORG:
      return { ...state, orgProfileAdded: action.payload };

    default:
      return state;
  }
};

export default organizationReducer;
